import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-800672ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-list-main-container" }
const _hoisted_2 = { class: "scene-list-container" }
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-list-titles" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "scene-list-big-title" }, "对话场景切换"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("span", { class: "scene-list-small-title" }, "请在下方选择您想切换的对话场景")
], -1))
const _hoisted_5 = { class: "scene-grid" }
const _hoisted_6 = ["data-id", "onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "scene-text" }
const _hoisted_9 = {
  key: 0,
  class: "scene-action"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          id: "close-page",
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
        }, "×")
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentChatSceneItem, (scene, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["scene-item", { selected: scene.npcId === _ctx.selectedScene }]),
            "data-id": scene.id,
            onClick: ($event: any) => (_ctx.handleSceneClick(scene))
          }, [
            _createElementVNode("img", {
              src: require('../../assets/image/scene_bg1.svg'),
              alt: `Scene ${scene.id}`
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, _toDisplayString(scene.name), 1),
            (scene.npcId === _ctx.selectedScene)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "正在使用此场景"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("button", {
        id: "reset-button",
        class: "reset-button",
        disabled: _ctx.resetButtonDisabled,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleResetClick && _ctx.handleResetClick(...args)))
      }, _toDisplayString(_ctx.resetButtonText), 9, _hoisted_10)
    ])
  ]))
}